<template>
    <div>
        <block v-if="loading"></block>
        <v-form ref="form">
            <v-row class="ml-2 mr-2">
                <v-col class="tabsNH" cols="12">
                    <v-col cols="12" v-if="customerToShow"
                        style="display: flex; justify-content: flex-end; min-height: 50px">
                        <!-- <div>
                            <v-btn small v-if="$store.getters['rolesUser/getCustomRole'](19)" color="error"
                                @click="confirmDeleteCustomer()">
                                    <v-icon style="margin-left: 0.1rem"> mdi-delete </v-icon>
                            </v-btn>
                        </div> -->
                        <v-btn small class="btnclear mr-1" @click="clearForm">
                            <v-icon> mdi-broom </v-icon>
                        </v-btn>
                        <v-btn small class="btnblue mr-1" @click="showExamList = !showExamList">
                            <v-icon> mdi-magnify </v-icon>
                        </v-btn>
                        <div>
                            <v-btn small v-if="$store.getters['rolesUser/getCustomRole'](18)" class="mx-2 btn-save"
                                @click.prevent="insertCustomerExamData">
                                <v-icon style="margin-left: 0.1rem"> mdi-content-save </v-icon>
                            </v-btn>
                        </div>
                    </v-col>
                </v-col>

                <v-col cols="12" :class="customerToShow ? 'my-2' : 'my-6'">

                    <!-- <v-row> -->
                    <!-- <v-col cols="12"> -->
                    <v-card class="mt-3 px-2 py-1" v-if="IsOptical && customerToShow">
                        <v-row class="pa-3">
                            <v-col cols="12" class="mb-2">
                                <div class="text-h6 black--text">Examen de Óptica </div>
                            </v-col>
                            <v-col cols="12" md="6">
                                <date-picker label="Fecha de examen: " v-model="form.Date_Exam"></date-picker>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field outlined dense v-model="form.OccupationAndScreenTime"
                                    label="Ocupación y Tiempo en pantallas"></v-text-field>
                            </v-col>

                            <v-col cols="12" class="mt-0 mb-3">
                                <span class="subtitle-1">Lensometria</span>
                            </v-col>

                            <v-col cols="12" class="mt-0 mb-3 mx-2">
                                <v-row class="table-optica rounded-lg">
                                    <v-col cols="12" md="4" class="my-1">
                                        <table>
                                            <tr>
                                                <th class="text-start">OD</th>
                                                <td>
                                                    <v-text-field outlined dense hide-details
                                                        v-model="form.LensometryOD"></v-text-field>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th class="text-start">OI</th>
                                                <td>
                                                    <v-text-field outlined dense hide-details
                                                        v-model="form.LensometryOI"></v-text-field>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th class="text-start">Tipo de lente en uso</th>
                                                <td>
                                                    <v-text-field outlined dense hide-details
                                                        v-model="form.LensometryTypeCurrentLenses"></v-text-field>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-col>
                                    <v-col cols="12" md="8" class="my-1">
                                        <v-textarea outlined dense hide-details rows="6"
                                            label="Motivo de la visita, condición de salud (Presión arterial, Glucosa, cirugías, cataratas, pterigión, etc)"
                                            v-model="form.ReasonVisitAndHealth"></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-col>

                            <v-col cols="12" class="mt-5 mx-2">
                                <v-row class="table-optica rounded-lg">
                                    <v-col cols="12" md="4" class="my-1">
                                        <table>
                                            <tr>
                                                <th></th>
                                                <th>AV S.C.</th>
                                                <th>AV P.H.</th>
                                                <th>AV CC</th>
                                            </tr>
                                            <tr>
                                                <th>OD</th>
                                                <td>
                                                    <v-text-field outlined dense hide-details
                                                        v-model="form.OD_AV_SC"></v-text-field>
                                                </td>
                                                <td>
                                                    <v-text-field outlined dense hide-details
                                                        v-model="form.OD_AV_PH"></v-text-field>
                                                </td>
                                                <td>
                                                    <v-text-field outlined dense hide-details
                                                        v-model="form.OD_AV_CC"></v-text-field>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>OI</th>
                                                <td>
                                                    <v-text-field outlined dense hide-details
                                                        v-model="form.OI_AV_SC"></v-text-field>
                                                </td>
                                                <td>
                                                    <v-text-field outlined dense hide-details
                                                        v-model="form.OI_AV_PH"></v-text-field>
                                                </td>
                                                <td>
                                                    <v-text-field outlined dense hide-details
                                                        v-model="form.OI_AV_CC"></v-text-field>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>AO</th>
                                                <td>
                                                    <v-text-field outlined dense hide-details
                                                        v-model="form.AO_AV_SC"></v-text-field>
                                                </td>
                                                <td>
                                                    <v-text-field outlined dense hide-details
                                                        v-model="form.AO_AV_PH"></v-text-field>
                                                </td>
                                                <td>
                                                    <v-text-field outlined dense hide-details
                                                        v-model="form.AO_AV_CC"></v-text-field>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-col>
                                    <v-col cols="12" md="8" class="my-1">
                                        <v-textarea outlined dense hide-details rows="7"
                                            label="Historial ocular personal y familiar"
                                            v-model="form.PersonalFamilyOcularHistory"></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-col>

                            <v-col cols="12" class="mt-5">
                                <span class="subtitle-1">RX FINAL</span>
                            </v-col>

                            <v-col cols="12" class="my-3 mx-2">
                                <v-row class="table-optica rounded-lg">
                                    <v-col cols="12">
                                        <table>
                                            <tr>
                                                <th></th>
                                                <th>Esf</th>
                                                <th>Cil</th>
                                                <th>Eje</th>
                                                <th>Add</th>
                                                <th>Prisma</th>
                                            </tr>
                                            <tr>
                                                <th>OD</th>
                                                <td>
                                                    <v-text-field outlined dense hide-details
                                                        v-model="form.Final_OD_Esf"></v-text-field>
                                                </td>
                                                <td>
                                                    <v-text-field outlined dense hide-details
                                                        v-model="form.Final_OD_Cil"></v-text-field>
                                                </td>
                                                <td>
                                                    <v-text-field outlined dense hide-details
                                                        v-model="form.Final_OD_Eje"></v-text-field>
                                                </td>
                                                <td>
                                                    <v-text-field outlined dense hide-details
                                                        v-model="form.Final_OD_Add"></v-text-field>
                                                </td>
                                                <td>
                                                    <v-text-field outlined dense hide-details
                                                        v-model="form.Final_OD_Pris"></v-text-field>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>OI</th>
                                                <td>
                                                    <v-text-field outlined dense hide-details
                                                        v-model="form.Final_OI_Esf"></v-text-field>
                                                </td>
                                                <td>
                                                    <v-text-field outlined dense hide-details
                                                        v-model="form.Final_OI_Cil"></v-text-field>
                                                </td>
                                                <td>
                                                    <v-text-field outlined dense hide-details
                                                        v-model="form.Final_OI_Eje"></v-text-field>
                                                </td>
                                                <td>
                                                    <v-text-field outlined dense hide-details
                                                        v-model="form.Final_OI_Add"></v-text-field>
                                                </td>
                                                <td>
                                                    <v-text-field outlined dense hide-details
                                                        v-model="form.Final_OI_Pris"></v-text-field>
                                                </td>
                                            </tr>
                                        </table>

                                        <table>
                                            <tr>
                                                <th>DP</th>
                                                <td>
                                                    <v-text-field outlined dense hide-details
                                                        v-model="form.Final_DP"></v-text-field>
                                                </td>
                                                <th>AP</th>
                                                <td>
                                                    <v-text-field outlined dense hide-details
                                                        v-model="form.Final_AP"></v-text-field>
                                                </td>
                                                <th>AO</th>
                                                <td>
                                                    <v-text-field outlined dense hide-details
                                                        v-model="form.Final_AO"></v-text-field>
                                                </td>
                                                <th>Corredor</th>
                                                <td>
                                                    <v-text-field outlined dense hide-details
                                                        v-model="form.Final_Corredor"></v-text-field>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-col>
                                </v-row>
                            </v-col>

                            <v-col cols="12" class="my-2">
                                <v-text-field outlined dense hide-details v-model="form.RecommendedLenses"
                                    label="Lente recomendado"></v-text-field>
                            </v-col>
                            <v-col cols="12" class="mt-2 mb-3">
                                <v-text-field outlined dense hide-details v-model="form.Observations"
                                    label="Observaciones"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card>
                    <!-- </v-col> -->
                    <!-- </v-row> -->

                </v-col>

            </v-row>
        </v-form>

        <alerts v-if="alert.show" v-on:close_alert="closeAlert" v-on:accept_alert="acceptAlert" :properties="alert">
        </alerts>

        <v-dialog v-model="showExamList" :width="'90%'" scrollable>
            <block v-if="loading"></block>
            <v-card class="pa-4">
                <v-card-text>
                    <div style="
                    margin-top: 0.3rem;
                    margin-bottom: 0.3rem;
                    display: flex;
                    justify-content: flex-end;
                ">
                        <v-btn small class="btndelete" @click.prevent="showExamList = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                    <GeneralFilter entity="Lista de examenes" :filterEndpoint="getExamListData" :search="search"
                        @emptyFilter="getExamListData">
                        <DxDataGrid class="isScrolledByGeneralFilter" :show-borders="true" :data-source="examListData"
                            key-expr="" :column-auto-width="true" style="width: fit-content;">
                            <!-- <DxExport :enabled="true" /> -->
                            <DxPaging :page-size="10" />
                            <DxColumn :width="80" cell-template="show-template" caption=""></DxColumn>
                            <DxColumn data-field="Date_Exam" caption="Fecha"></DxColumn>
                            <DxColumn data-field="RecommendedLenses" caption="Lente recomendado"></DxColumn>
                            <DxColumn data-field="OccupationAndScreenTime" caption="Ocupación y Tiempo en pantallas">
                            </DxColumn>
                            <DxColumn cell-template="show-template-user" caption="Usuario"></DxColumn>
                            <DxColumn v-if="$store.getters['rolesUser/getCustomRole'](165)" cell-template="show-delete"
                                :width="80" caption=""></DxColumn>
                            <template #show-template="{ data }">
                                <div>
                                    <a href="#" @click.prevent.stop="
                                        selectExam(data.data);
                                    showExamList = false;
                                    ">
                                        <v-icon color="primary">mdi-eye</v-icon>
                                    </a>
                                </div>
                            </template>
                            <template #show-template-user="">
                                <div>
                                    {{ customerToShow.LegalName }}
                                </div>
                            </template>
                            <template #show-delete="{ data }">
                                <div>
                                    <a href="" class="mx-2" @click.prevent.stop="
                                        examToDelete = data.data;
                                    showAlert(
                                        'question',
                                        'Eiminar',
                                        '¿Está seguro de eliminar este registro?',
                                        'ConfirmDeleteCustomerExam'
                                    );

                                    showExamList = false;
                                    ">
                                        <v-icon color="error">mdi-delete</v-icon>
                                    </a>
                                </div>
                            </template>
                        </DxDataGrid>
                    </GeneralFilter>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import Block from "../../../components/Block";
import Alerts from "../../../components/Alerts";
import moment from "moment";
import DatePicker from "../../../components/DatePicker2.vue";
import GeneralFilter from "@/components/GeneralFilter.vue";
import {
    DxDataGrid,
    DxColumn,
    DxPaging,
    // DxExport 
} from "devextreme-vue/data-grid";
import { formatDate } from "../../../helpers/formatDate";

const getEmptyForm = () => ({
    Date_Exam: formatDate(
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substring(0, 10)
    ),
    OccupationAndScreenTime: "",
    ReasonVisitAndHealth: "",
    LensometryOD: "",
    LensometryOI: "",
    LensometryTypeCurrentLenses: "",
    OD_AV_SC: "",
    OD_AV_PH: "",
    OD_AV_CC: "",
    OI_AV_SC: "",
    OI_AV_PH: "",
    OI_AV_CC: "",
    AO_AV_SC: "",
    AO_AV_PH: "",
    AO_AV_CC: "",
    PersonalFamilyOcularHistory: "",
    Final_OD_Esf: "",
    Final_OD_Cil: "",
    Final_OD_Eje: "",
    Final_OD_Add: "",
    Final_OD_Pris: "",
    Final_OI_Esf: "",
    Final_OI_Cil: "",
    Final_OI_Eje: "",
    Final_OI_Add: "",
    Final_OI_Pris: "",
    Final_DP: "",
    Final_AP: "",
    Final_AO: "",
    Final_Corredor: "",
    RecommendedLenses: "",
    Observations: "",
});

export default {
    name: "CustomerExams",
    components: { Block, Alerts, DatePicker, DxDataGrid, DxColumn, DxPaging, GeneralFilter },
    props: ["customerToShow", "win"],
    data() {
        return {
            alert: {
                type: "success",
                show: false,
                header: "",
                body: "",
            },
            examToDelete: null,
            ID_Branch: JSON.parse(localStorage.getItem("branch"))?.ID_Branch || null,
            form: getEmptyForm(),
            loading: false,
            search: {},
            showExamList: false,
            examListData: [],
            IsOptical: JSON.parse(localStorage.getItem("user")).IsOptical,
        };
    },
    async mounted() {
        if (this.customerToShow) {
            this.form.ID_Customer = this.customerToShow.ID_Customer;
            this.form.ID_Business = this.customerToShow.ID_Business;
            this.form.ID_Branch = this.ID_Branch;
            await this.getExamListData();
        }
    },
    methods: {
        clearForm() {
            this.form = {
                ...getEmptyForm(),
                ID_Customer: this.customerToShow?.ID_Customer,
                ID_Business: this.customerToShow?.ID_Business,
                ID_Branch: this.ID_Branch,
            };

            this.$refs.form?.resetValidation();
        },
        getExamListData({ filter } = {}) {
            this.loading = true;
            this.$API.customersOptica.getCustomersOptica({ ID_Customer: this.customerToShow.ID_Customer, filter }).then(
                (res) => {
                    res.forEach(element => {
                        if (element.Date_Exam) {
                            element.Date_Exam = moment(element.Date_Exam, 'YYYY-MM-DD').format("DD/MM/YYYY");
                        }
                    })
                    this.examListData = res;
                },
                (err) => {
                    console.log(err);

                    //this.$toasted.error(err.message);
                }
            ).finally(() => {
                this.loading = false;
            });
        },
        selectExam(data) {
            this.form = { ...data };
        },
        closeAlert() {
            this.alert.show = false;
            if (this.alert.options == "redirectcustomerdeleted") {
                this.getExamListData();
            }
        },
        acceptAlert() {
            this.alert.show = false;

            if (this.alert.options == "ConfirmDeleteCustomerExam") {
                this.deleteCustomer();
            }
        },
        showAlert(type, header, body, options = null) {
            type = type == null ? "danger" : type;
            this.alert.type = type;
            this.alert.header = header;
            this.alert.body = body;
            this.alert.show = true;
            this.alert.options = options != null ? options : null;
        },
        async insertCustomerExamData() {
            try {
                this.loading = true;
                const valid = this.$refs.form.validate();
                if (!valid) {
                    this.showAlert(
                        "warning",
                        "Advertencia",
                        "Debe completar todos los campos obligatorios"
                    );
                    return;
                }

                const insertData = await this.$API.customersOptica.addCustomerOpticaExamData(this.form)

                if (this.form.id_customer_optica) {
                    this.showAlert(
                        "warning",
                        "Actualización Correcta",
                        insertData.message,
                        "updateCustomer"
                    );
                } else {
                    this.showAlert(
                        "success",
                        "Creación Correcta",
                        insertData.message,
                        "updateCustomer"
                    );
                }
                await this.getExamListData();
                this.clearForm();
            } catch (error) {
                this.loading = false;
                this.showAlert(
                    "danger",
                    "Ocurrio un problema",
                    "Ha ocurrido un problema por favor contacte al administrador o intente mas tarde"
                );
            } finally {
                this.loading = false;
            }
        },
        async deleteCustomer() {
            this.loading = true;
            await this.$API.customersOptica
                .logicalDeleteCustomerExam(this.examToDelete.id_customer_optica)
                .then(() => {
                    this.showAlert(
                        "success",
                        "Eliminación correcta",
                        "Examen de cliente eliminado correctamente",
                        "redirectcustomerdeleted"
                    );
                })
                .catch(() => {
                    this.showAlert(
                        "danger",
                        "Ocurrio un problema",
                        "Ha ocurrido un problema por favor contacte al administrador o intente mas tarde"
                    );
                }).finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>

<style scoped>
.btnsave {
    background-color: #00a178 !important;
    color: white;
}

.btnblue {
    background-color: #1976d2 !important;
    color: white;
}

.btnclear {
    background-color: #e89906 !important;
    color: white;
}

.tabs {
    width: 100%;
    padding: 10px;
    background-color: rgba(60, 60, 60, 1);
    color: white !important;
    border-style: solid;
    border-color: black;
    border-width: 1px;

    border-radius: 10px;
}

.tabsNH {
    padding: 10px;
    background-color: rgba(60, 60, 60, 1);
    color: white !important;
    border-style: solid;
    border-color: black;
    border-width: 1px;

    border-radius: 10px;
}

.tabsContent {
    width: 100%;
    padding: 10px;
    background-color: #f29d35;
    color: white !important;
    border-style: solid;
    border-color: black;
    border-width: 1px;

    border-radius: 10px;
}

.box {
    border-style: solid;
    border-color: black;
    border-width: 1px;

    border-radius: 15px;
}

.formButton:hover {
    background-color: rgba(80, 80, 80, 1);
    cursor: pointer;
}

.tabsContent:hover {
    background-color: #ffb266;
    cursor: pointer;
}

.table-optica {
    border: 1px solid #444;
    width: 100%;
}

.table-optica td,
.table-optica th {
    padding: 7px;
}
</style>
